var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",attrs:{"preload":"metadata","playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.computedSrc,"type":_vm.mime}})])}
var staticRenderFns = []

export { render, staticRenderFns }